angular
  .module('surfsightApp.controllers')

  .controller('FamiliarDriverController', [
    '$rootScope',
    '$scope',
    '$localStorage',
    '$translate',
    function ($rootScope, $scope, $localStorage, $translate) {
      const translationsSrc = () => {
        return `./locale/lytx-album-management/${$translate.use()}.json`
      }

      $scope.albumManagementProperties = {
        authToken: $localStorage.userToken,
        organizationId: $localStorage.currentUserOrganization.id,
        amplitudeKey: AMPLITUDE_KEY,
        translationsSrc: translationsSrc()
      }

      $rootScope.$on('$translateChangeSuccess', function () {
        $scope.albumManagementProperties.translationsSrc = translationsSrc()
        $scope.$applyAsync()
      })
    }
  ])
